// extracted by mini-css-extract-plugin
module.exports = {"wantItem":"WantItem_wantItem__q69M4"};